import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuButton: {
      marginLeft: 0,
    },
    containerHeader: {
      height: 44,
      minHeight: "unset",
      paddingLeft: 0,
    },
    toolbar: {
      position: "sticky",
      top: 0,
      maxWidth: 1024,
      margin: "auto",
      backgroundColor: "#6A46E5",
      color: "white",
    },
    searchWrapper: {
      backgroundColor: "#6A46E5",
      padding: "4px 8px 8px",
    },
    searchRow: {
      display: "flex",
      alignItems: "center",
      gap: 8,
    },
    searchContainer: {
      display: "flex",
      alignItems: "center",
      flex: 1,
      backgroundColor: "#ffffff",
      borderRadius: 4,
      padding: "2px 8px",
    },
    searchInput: {
      flex: 1,
      fontSize: 14,
    },
    searchIcon: {
      padding: "0px 4px 0px 4px",
      pointerEvents: "none",
      "& svg": {
        fontSize: 24,
        color: "gray",
        opacity: 0.5,
      },
    },
    cancelText: {
      color: "white",
      fontSize: 14,
      cursor: "pointer",
    },
    title: {
      flexGrow: 1,
      textAlign: "center",
      fontSize: 20,
    },
    iconphone: {
      marginRight: -15,
    },
    fontHarabara: {
      fontFamily: "Harabara",
      fontSize: 26,
    },
    fontSmall: {
      fontSize: 14,
    },
  })
);

export default useStyles;
